import { IIconProps } from './add';

export const IcoArrowUp: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoArrowUp${cy}`}
    style={style}
  >
    <path
      d="M1.645 9.32273L7 3.9794L12.355 9.32273L14 7.67773L7 0.677734L0 7.67773L1.645 9.32273Z"
      fill="#383939"
    />
  </svg>
);
